import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import { fetchCollectionsFailure, fetchCollectionsSuccess } from "domains/collection/actions";
import type { FetchCollectionsAction } from "domains/collection/actionTypes";
import type { CollectionViewResponse } from "domains/collection/types/collectionResponses";
import { CollectionType } from "domains/collection/types/collectionType";

export function* fetchCollectionsSaga({ payload }: FetchCollectionsAction) {
  try {
    const { limit, offset, type } = payload;
    const queryParams = { ...queryParamsForType(type), limit, offset };
    const response: CollectionViewResponse[] = yield apiFetch("collection", { queryParams });
    yield put(fetchCollectionsSuccess({ ...payload, response }));
  } catch (error) {
    logger.error("[fetchCollectionsSaga] Failed to fetch collections", error);
    yield put(fetchCollectionsFailure(payload));
  }
}

const queryParamsForType = (type: CollectionType) => {
  if (type === CollectionType.Featured) return { featured: "true" };
  if (type === CollectionType.Listed) return { listed: "true" };
  return {};
};
